import React from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Link, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import { useSelector } from "react-redux";
import { ExtraPaddingLeftStyledCell, StyledTableCell } from "../../../components/commonComponents/TabularLists/styles";
import { StyledDarkRedInformationTypography, StyledStack } from "../../../components/commonComponents/StyledComponents/styled";
import CloseButton from "../../../components/commonComponents/Buttons/CloseButton";
import { ArrowDropDown, ArrowDropUp, Close } from "@mui/icons-material";
import { sortListingStoresData } from "../../../api_calls/listingCheck";
import { checkUserDetailsFromCookie } from "../../../api_calls/userManagement";

const ListingCheckStoresList = ({ open, closeModal, selectedGtin }) => {
    const storeDetails = useSelector((state) => state.userSelections);
    const checkUserDetails = checkUserDetailsFromCookie();
    const ownerAllowedUserTypes = ["cyreen", "branch"];
    const [sortingMeasure, setSortingMeasure] = React.useState({
        store_name: "asc",
        street: "asc",
        zip: "asc",
        city: "asc",
        region: "asc",

    });
    // store details 
    const storeList = typeof storeDetails.sorted_listing_check_stores_data !== "undefined" ? storeDetails.sorted_listing_check_stores_data : [];

    return (
        <Dialog
            open={open}
            onClose={(e) => {
                e.preventDefault();
            }}
            fullWidth={true}
            maxWidth={"lg"}
        // fullScreen
        >
            <DialogTitle> Listing Check Stores </DialogTitle>
            <DialogContent>
                <StyledDarkRedInformationTypography variant="p" sx={{ marginBottom: "10px", fontSize: "14px" }}>
                    {`GTIN: ${selectedGtin} `}
                </StyledDarkRedInformationTypography>
                <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                    <Table aria-label="customized table">
                        {/* ------ header row ------ */}
                        <TableHead>
                            <TableRow>
                                {/* ----- store name */}
                                <ExtraPaddingLeftStyledCell align="left" className="text-wrapper" sx={{ padding: "5px", fontSize: "13px" }}>
                                    <Stack direction={"row"} spacing={1}>
                                        <div>Store Name</div>
                                        {sortingMeasure.store_name === "asc" ? (
                                            <ArrowDropDown
                                                sx={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    setSortingMeasure((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            store_name: prevState.store_name === "asc" ? "desc" : "asc",
                                                        };
                                                    });
                                                    // sort the listing in redux state
                                                    sortListingStoresData("store_name", sortingMeasure.store_name === "asc" ? "desc" : "asc");
                                                }}
                                            />
                                        ) : (
                                            <ArrowDropUp
                                                sx={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    setSortingMeasure((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            store_name: prevState.store_name === "asc" ? "desc" : "asc",
                                                        };
                                                    });
                                                    // sort the listing in redux state
                                                    sortListingStoresData("store_name", sortingMeasure.store_name === "asc" ? "desc" : "asc");
                                                }}
                                            />
                                        )}
                                    </Stack>

                                </ExtraPaddingLeftStyledCell>
                                {/* ---- street and no. ------- */}
                                <StyledTableCell align="left" className="text-wrapper" sx={{ padding: "5px", fontSize: "13px" }}>
                                    <Stack direction={"row"} spacing={1}>
                                        <div>Street & No.</div>
                                        {sortingMeasure.street === "asc" ? (
                                            <ArrowDropDown
                                                sx={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    setSortingMeasure((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            street: prevState.street === "asc" ? "desc" : "asc",
                                                        };
                                                    });
                                                    // sort the listing in redux state
                                                    sortListingStoresData("street", sortingMeasure.street === "asc" ? "desc" : "asc");
                                                }}
                                            />
                                        ) : (
                                            <ArrowDropUp
                                                sx={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    setSortingMeasure((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            street: prevState.street === "asc" ? "desc" : "asc",
                                                        };
                                                    });
                                                    // sort the listing in redux state
                                                    sortListingStoresData("street", sortingMeasure.street === "asc" ? "desc" : "asc");
                                                }}
                                            />
                                        )}
                                    </Stack>
                                </StyledTableCell>
                                {/* --------- zip code --------- */}
                                <StyledTableCell align="left" className="text-wrapper" sx={{ padding: "5px", fontSize: "13px" }}>
                                    <Stack direction={"row"} spacing={1}>
                                        <div>ZIP Code</div>
                                        {sortingMeasure.zip === "asc" ? (
                                            <ArrowDropDown
                                                sx={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    setSortingMeasure((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            zip: prevState.zip === "asc" ? "desc" : "asc",
                                                        };
                                                    });
                                                    // sort the listing in redux state
                                                    sortListingStoresData("zip", sortingMeasure.zip === "asc" ? "desc" : "asc");
                                                }}
                                            />
                                        ) : (
                                            <ArrowDropUp
                                                sx={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    setSortingMeasure((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            zip: prevState.zip === "asc" ? "desc" : "asc",
                                                        };
                                                    });
                                                    // sort the listing in redux state
                                                    sortListingStoresData("zip", sortingMeasure.zip === "asc" ? "desc" : "asc");
                                                }}
                                            />
                                        )}
                                    </Stack>
                                </StyledTableCell>
                                {/* --------- city ---------- */}
                                <StyledTableCell align="left" className="text-wrapper" sx={{ padding: "5px", fontSize: "13px" }}>
                                    <Stack direction={"row"} spacing={1}>
                                        <div>City</div>
                                        {sortingMeasure.city === "asc" ? (
                                            <ArrowDropDown
                                                sx={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    setSortingMeasure((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            city: prevState.city === "asc" ? "desc" : "asc",
                                                        };
                                                    });
                                                    // sort the listing in redux state
                                                    sortListingStoresData("city", sortingMeasure.city === "asc" ? "desc" : "asc");
                                                }}
                                            />
                                        ) : (
                                            <ArrowDropUp
                                                sx={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    setSortingMeasure((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            city: prevState.city === "asc" ? "desc" : "asc",
                                                        };
                                                    });
                                                    // sort the listing in redux state
                                                    sortListingStoresData("city", sortingMeasure.city === "asc" ? "desc" : "asc");
                                                }}
                                            />
                                        )}
                                    </Stack>
                                </StyledTableCell>
                                {/* ----------- region -------- */}
                                <StyledTableCell align="left" className="text-wrapper" sx={{ padding: "5px", fontSize: "13px" }}>
                                    <Stack direction={"row"} spacing={1}>
                                        <div>Region</div>
                                        {sortingMeasure.region === "asc" ? (
                                            <ArrowDropDown
                                                sx={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    setSortingMeasure((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            region: prevState.region === "asc" ? "desc" : "asc",
                                                        };
                                                    });
                                                    // sort the listing in redux state
                                                    sortListingStoresData("region", sortingMeasure.region === "asc" ? "desc" : "asc");
                                                }}
                                            />
                                        ) : (
                                            <ArrowDropUp
                                                sx={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    setSortingMeasure((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            region: prevState.region === "asc" ? "desc" : "asc",
                                                        };
                                                    });
                                                    // sort the listing in redux state
                                                    sortListingStoresData("region", sortingMeasure.region === "asc" ? "desc" : "asc");
                                                }}
                                            />
                                        )}
                                    </Stack>
                                </StyledTableCell>
                                {/* ------------ owner ----------- */}
                                {
                                    ownerAllowedUserTypes.includes(checkUserDetails.user_detail.user_type.toLowerCase()) && (
                                        <StyledTableCell align="left" className="text-wrapper" sx={{ padding: "5px", fontSize: "13px" }}>
                                            <Stack direction={"row"} spacing={1}>
                                                <div>Owner</div>
                                                {sortingMeasure.owner === "asc" ? (
                                                    <ArrowDropDown
                                                        sx={{ cursor: "pointer" }}
                                                        onClick={(e) => {
                                                            setSortingMeasure((prevState) => {
                                                                return {
                                                                    ...prevState,
                                                                    owner: prevState.owner === "asc" ? "desc" : "asc",
                                                                };
                                                            });
                                                            // sort the listing in redux state
                                                            sortListingStoresData("owner", sortingMeasure.owner === "asc" ? "desc" : "asc");
                                                        }}
                                                    />
                                                ) : (
                                                    <ArrowDropUp
                                                        sx={{ cursor: "pointer" }}
                                                        onClick={(e) => {
                                                            setSortingMeasure((prevState) => {
                                                                return {
                                                                    ...prevState,
                                                                    owner: prevState.owner === "asc" ? "desc" : "asc",
                                                                };
                                                            });
                                                            // sort the listing in redux state
                                                            sortListingStoresData("owner", sortingMeasure.owner === "asc" ? "desc" : "asc");
                                                        }}
                                                    />
                                                )}
                                            </Stack>
                                        </StyledTableCell>
                                    )
                                }

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {storeList.map((store, index) => {
                                return (
                                    <TableRow key={index + "_campaign_row"}>
                                        {/* --------- name ---------- */}
                                        <ExtraPaddingLeftStyledCell
                                            component="td"
                                            scope="row"
                                            className="text-wrapper"
                                            sx={{ padding: "5px" }}
                                        >
                                            {store.name}
                                        </ExtraPaddingLeftStyledCell>
                                        {/* ---------- street and no. --------- */}
                                        <StyledTableCell component="td" scope="row" className="text-wrapper" sx={{ padding: "5px" }}>
                                            {store.address}
                                        </StyledTableCell>
                                        {/* ---------- zip code --------- */}
                                        <StyledTableCell component="td" scope="row" className="text-wrapper" sx={{ padding: "5px" }}>
                                            {store.zipCode}
                                        </StyledTableCell>
                                        {/* ---------- city --------- */}
                                        <StyledTableCell component="td" scope="row" className="text-wrapper" sx={{ padding: "5px" }}>
                                            {store.city}
                                        </StyledTableCell>
                                        {/* ---------- region --------- */}
                                        <StyledTableCell component="td" scope="row" className="text-wrapper" sx={{ padding: "5px" }}>
                                            {store.region.name}
                                        </StyledTableCell>
                                        {/* ---------- owner --------- */}
                                        {
                                            ownerAllowedUserTypes.includes(checkUserDetails.user_detail.user_type) && (
                                                <StyledTableCell component="td" scope="row" className="text-wrapper" sx={{ padding: "5px" }}>
                                                    {store.company.name}
                                                </StyledTableCell>
                                            )
                                        }

                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <CloseButton
                    onClick={(e) => {
                        e.preventDefault();
                        closeModal();
                    }}
                    label="Close"
                    icon={<Close />}
                />

            </DialogActions>
        </Dialog>
    );
};

export default ListingCheckStoresList;
